import { AppConstants } from "../../../../app.constants";

export class LegalConsentModel {
  constructor(
    public Title: string = AppConstants.LEGAL_CONSENT_DEFAULT_TITLE,
    public Text: string = AppConstants.LEGAL_CONSENT_DEFAULT_TEXT,
    public Id?: number
  ) {}
}
